import { render, staticRenderFns } from "./CreditNoteEditor.vue?vue&type=template&id=454870a6&"
import script from "./CreditNoteEditor.vue?vue&type=script&lang=js&"
export * from "./CreditNoteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports